module.exports = __webpack_public_path__ + "media/styles/images/svg/projects-teal-f6c06d7da6a393c7d2986ab7ce1c88b4.svg";